import columnsValues from '@/HTable/columnsValues'

export default {
  data () {
    return {
      columns: [
        {
          label: 'Имя',
          field: 'first_name',
          name: 'first_name',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Фамилия',
          field: 'last_name',
          name: 'last_name',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Email',
          field: 'email',
          name: 'email',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Телефон',
          field: 'phone_number',
          name: 'phone_number',
          sortable: false,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Роль',
          field: 'role',
          name: 'role',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.roles,
          format: val => {
            return this.formatValue(val, 'role')
          },
        },
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
        },
        {
          label: 'Дата обновления',
          field: 'updated_at',
          name: 'updated_at',
          sortable: true,
          filter: {},
          align: 'left',
          type: 'date',
        },
        {
          label: 'Действия',
          name: 'edit',
          field: 'id',
          sortable: false,
          align: 'right',
        },
      ],
    }
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/UsersList/mixins/columns.js